<template>
  <div class="content">
    <form class="form-horizontal" @submit.prevent="">
      <div class="row">
        <div class="col-sm-12">
          <base-button @click="setPage(100)" type="info">갤러리 설정</base-button>
          <base-button @click="setPage(200)" type="info">토픽 설정</base-button>
          <base-button @click="setPage(700)" type="info">팬로그 설정</base-button>
          <base-button @click="setPage(30)" type="info">프로필 설정</base-button>
          <base-button @click="setPage(400)" type="info">스케줄 설정</base-button>
          <base-button @click="initSitemapIndex()" type="info">사이트맵 인덱스 설정</base-button>
          <base-button @click="clearCache()" type="danger">캐시초기화</base-button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { BaseButton } from "@/components/index";

export default {
  components: {
    BaseButton,
  },
  async created() {},
  data() {
    return {};
  },
  methods: {
    async clearCache() {
      await this.$axios.post(`/homepage/invalidate`);
      Toast.success("캐시가 초기화되었습니다");
    },
    async setPage(namespace) {
      await this.$axios.post(`/homepage/sitemap/${namespace}`);
      Toast.success("사이트맵이 설정되었습니다");
    },
    async initSitemapIndex() {
      await this.$axios.post(`/homepage/sitemap`);
      Toast.success("사이트맵 인덱스가 설정되었습니다");
    },
  },
};
</script>
